module.exports = __webpack_public_path__ + "static/media/404err.a42d6a0d.png";